module.exports = __webpack_public_path__ + "img/leaf-heart.e13f7049.svg";